import React, { forwardRef } from "react";

import { faTimes } from "@fortawesome/pro-solid-svg-icons/faTimes";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Col from "antd/es/col";
import Row from "antd/es/row";
import { useIntl } from "react-intl";

import CumulDashboard from "@mapmycustomers/shared/types/cumul/CumulDashboard";

import EmbeddedModal from "@app/component/modal/EmbeddedModal";
import { CumulDashboardViewMode } from "@app/scene/reports/enums/CumulDashboardViewMode";

import ShowDashboard, { LuzmoDashboardRef } from "../Dashboard";
import DashboardHeader from "../DashboardHeader";

import styles from "./ViewDashboard.module.scss";

interface Props {
  dashboardId: string;
  hasEditAccess?: boolean;
  isDashboardPinned: boolean;
  isExportRunning: boolean;
  onChangeMode: (mode: CumulDashboardViewMode) => void;
  onExport?: () => void;
  onFullScreen?: () => void;
  onHide: () => void;
  onTogglePinnedDashboard: () => void;
  pinnedDashboardIds?: CumulDashboard["id"][];
  title?: string;
  viewMode: CumulDashboardViewMode;
}

const ViewDashboard = forwardRef<LuzmoDashboardRef, Props>(
  (
    {
      dashboardId,
      hasEditAccess,
      isDashboardPinned,
      isExportRunning,
      onChangeMode,
      onExport,
      onFullScreen,
      onHide,
      onTogglePinnedDashboard,
      pinnedDashboardIds,
      title,
      viewMode,
    },
    ref
  ) => {
    const intl = useIntl();

    return (
      <EmbeddedModal open>
        <div className={styles.bodyContainer}>
          <Row align="middle" className={styles.headerContainer} justify="space-between">
            <Col>
              <div className={styles.title}>
                {title
                  ? title
                  : viewMode === CumulDashboardViewMode.VIEW
                  ? intl.formatMessage({
                      id: "reports.cumul.dashboard.header.view.title",
                      defaultMessage: "View Dashboard",
                      description: "Title of dashboard",
                    })
                  : viewMode === CumulDashboardViewMode.EDIT_LIMITED
                  ? intl.formatMessage({
                      id: "reports.cumul.dashboard.header.edit.title",
                      defaultMessage: "Edit Dashboard",
                      description: "Title of edit dashboard",
                    })
                  : undefined}
              </div>
            </Col>
            <Col>
              <FontAwesomeIcon
                className={styles.closeIcon}
                icon={faTimes}
                onClick={onHide}
                size="lg"
              />
            </Col>
          </Row>
          <div className={styles.container}>
            {
              <DashboardHeader
                className={styles.dashboardContainer}
                dashboardId={dashboardId}
                hasEditAccess={hasEditAccess}
                isDashboardPinned={isDashboardPinned}
                isExportRunning={isExportRunning}
                onChangeMode={onChangeMode}
                onExport={onExport}
                onFullScreen={onFullScreen}
                onTogglePinedDashboard={onTogglePinnedDashboard}
                pinnedDashboardIds={pinnedDashboardIds}
                viewMode={viewMode}
              />
            }
            <ShowDashboard dashboardId={dashboardId} ref={ref} viewMode={viewMode} />
          </div>
        </div>
      </EmbeddedModal>
    );
  }
);

export default ViewDashboard;
